import { createSlice, createSelector } from '@reduxjs/toolkit';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, initMapFactory } from '../common/reducers/utilities';
import { ensureArray } from '../common/utils/arrayUtilities';

const compareBeaconRequests = (b1, b2) => b1.id === b2.id;

const beaconSlice = createSlice({
    name: 'beacon',
    initialState: {
        data: [],
    },
    reducers: {
        addOrUpdate: (state, action) => {
            for (const request of ensureArray(action.payload)) {
                let idx = state.data.findIndex(r => compareBeaconRequests(r, request));
                if (idx >= 0) {
                    state.data.splice(idx, 1, request);
                } else {
                    state.data.push(request);
                }
            }
        },
        remove: (state, action) => {
            for (const request of ensureArray(action.payload)) {
                let idx = state.data.findIndex(r => compareBeaconRequests(r, request));
                if (idx >= 0) {
                    state.data.splice(idx, 1);
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => beaconSlice.getInitialState());
    }
})

// #region network operations
const fetchBeaconRequest = (kind, key) => network => {
    if (!kind || !key) {
        return Promise.reject('Both kind and key must be supplied');
    }
    network.get('/api/v1/beaconrequest/' + encodeURIComponent(kind) + '/' + encodeURIComponent(key), beaconSlice.actions.addOrUpdate);
}
export const makeBeaconRequest = (network, request) => network.post('/api/v1/beaconrequest', request, beaconSlice.actions.addOrUpdate);
export const cancelBeaconRequest = (network, request) => network.delete('/api/v1/beaconrequest/' + encodeURIComponent(request.id), beaconSlice.actions.addOrUpdate);
// #endregion

// #region selectors
const selectRequests = state => state.beacon.data;

const selectByKindKey = createSelector([selectRequests, (requests, kind) => kind, (requests, kind, key) => key], (requests, kind, key) => requests.find(r => r.kind === kind && r.key === key));
const selectRequest = (kind, key) => state => selectByKindKey(state, kind, key);
// #endregion

// #region listeners
const listen = {
    beaconRequested: (request, { dispatch }) => dispatch(beaconSlice.actions.addOrUpdate(request)),
    beaconCancelled: (request, { dispatch }) => dispatch(beaconSlice.actions.remove(request))
}
// #endregion

const cleanup = { root: 'beacon', all: selectRequests, remove: request => beaconSlice.actions.remove(request) };

export const [useBeaconRequest] = dataHookFactory(selectRequest, initMapFactory(fetchBeaconRequest, listen), { cleanup });

const reducerDetails = { name: beaconSlice.name, reducer: beaconSlice.reducer };
export default reducerDetails;